import React, { useEffect, useState } from "react";
import Header from "../../CustomComponents/Header/Header";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import SingleSearchForm from "../../CustomComponents/SingleSearchForm/SingleSearchForm";
import Loader from "../../CustomComponents/Loader/Loader";
import Footer from "../../CustomComponents/Footer/Footer";
import { animateScroll as scroll } from "react-scroll";
import DestinationLinks from "../../CustomComponents/DestinationLinks/DestinationLinks";
import CustomPagination from "../../CustomComponents/CustomPagination/CustomPagination";
import NoDataFound from "../../CustomComponents/NoDataFound/NoDataFound";
import StarRating from "../../CustomComponents/StarRating/StarRating";
import Slider from "react-slick";
import CustomListingCard from "../../CustomComponents/CustomListingCard/CustomListingCard";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import PageMetaData from "../../CustomComponents/PageMetaData/PageMetaData";
import Skeleton from "react-loading-skeleton";
import SkeletonLoader from "../../CustomComponents/SkeletonLoader/SkeletonLoader";
import imgNotFound from "../../assets/images/single-image.png";
import AllHotelsSearchForm from "../../CustomComponents/AllHotelsSearchForm/AllHotelsSearchForm";
import {
  currentDateSingle,
  formatIndianCurrency,
  scrollToTop,
} from "../../utils/utils";
import OgMetaTitles from "../../CustomComponents/PageMetaData/OgMetaTitles";
import SendEnquiryPopup from "../../CustomComponents/SendEnquiryPopup/SendEnquiryPopup";
import NewSendEnquiryPopup from "../../CustomComponents/NewSendEnquiryPopup/NewSendEnquiryPopup";
import NewUiHeader from "../../CustomComponents/NewComponents/NewUIHeader/NewUIHeader";

import styles from "./SingleDestinationsData.module.scss";
import NewUIPackageCard from "../../CustomComponents/NewComponents/NewUIPackages/NewUIPackageCard";
import HotelCard from "../../CustomComponents/NewComponents/NewUiHotels/HotelCard";
import NewUIActivitypageCard from "../../CustomComponents/NewComponents/NewUiActivities/NewUIActivityPageCard";
import NewFooterUI from "../../CustomComponents/NewComponents/NewFooterUI/NewFooterUI";
import ActivityQueryFormPopup from "../../CustomComponents/NewSendEnquiryPopup/ActivityQueryFormPopup";
function SingleDestinationsData() {
  var settings = {
    speed: 500,
    centerMode: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          infinite: true,
          // arrows:true
        },
      },
      {
        breakpoint: 565,
        settings: {
          infinite: true,
          slidesToShow: 3,
          // arrows:true
        },
      },
      {
        breakpoint: 450,
        settings: {
          infinite: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 375,
        settings: {
          infinite: true,
          slidesToShow: 1,
        },
      },
    ],
  };
  const { destination } = useParams();
  const [showRatePopup, setshowRatePopup] = useState(false);
  // console.log(destination, "destination");
  const location = useLocation();
  const [bookingData, setBookingData] = useState({});
  const [hotelData, setHotelData] = useState({});
  const navigate = useNavigate();
  const [singleDestinationData, setSingleDestinationData] = useState([]);
  const [showSendEnquiryPopup, setShowSendEnquiryPopup] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const displayedData =
    hotelData &&
    hotelData &&
    hotelData.length > 0 &&
    hotelData.slice(startIndex, endIndex);

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   const data = {
  //     hotelID: params.get("hotelID"),
  //     location: params.get("location"),
  //     room: params.get("room"),
  //     adult: params.get("adult"),
  //     children: params.get("children"),
  //     checkinDay: params.get("checkinDay"),
  //     checkinMonth: params.get("checkinMonth"),
  //     checkinYear: params.get("checkinYear"),
  //     checkoutDay: params.get("checkoutDay"),
  //     checkoutMonth: params.get("checkoutMonth"),
  //     checkoutYear: params.get("checkoutYear"),
  //     radio: params.get("radio"),
  //     childAge: params.get("childAge"),
  //   };
  //   setBookingData(data);
  //   postBookingData(data);
  // }, [location.search]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    const currentDate = currentDateSingle;

    const today = new Date(); // Today's date
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1); // Tomorrow's date

    const checkinDay = today.getDate();
    const checkinMonth = today.getMonth() + 1; // Month is 0-indexed, so add 1
    const checkinYear = today.getFullYear();

    const checkoutDay = tomorrow.getDate();
    const checkoutMonth = tomorrow.getMonth() + 1; // Month is 0-indexed, so add 1
    const checkoutYear = tomorrow.getFullYear();

    const data = {
      // hotelID: params.get("hotelID"),
      location: destination,
      room: params.get("room"),
      adult: params.get("adult"),
      children: params.get("children"),
      checkinDay: checkinDay,
      checkinMonth: checkinMonth,
      checkinYear: checkinYear,
      checkoutDay: checkoutDay,
      checkoutMonth: checkoutMonth,
      checkoutYear: checkoutYear,
      radio: params.get("radio"),
      childAge: childAges, // Assign the array of child ages
    };
    // console.log(hotelData, "data hotel")
    setBookingData(data);
    postBookingData(data);
  }, [location.search, destination]);

  const postBookingData = async (data) => {
    // setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const checkInDate = `${data.checkinYear}-${String(
      data.checkinMonth
    ).padStart(2, "0")}-${String(data.checkinDay).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    const formdata = new FormData();
    formdata.append("location", destination);
    formdata.append("checkIn", checkInDate);
    formdata.append("checkOut", checkOutDate);
    formdata.append("adults", 2);
    formdata.append("rooms", 1);
    formdata.append("limit", 8);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/hotel-engine/check-availability`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      setHotelData(result.data.properties);
      fetchDestinations(destination);
      fetchPackageData(destination);
      fetchActivities(destination);
      // setLoader(false);
      scrollToTop();
    } catch (error) {
      // setLoader(false);
      console.error("Error fetching properties:", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleViewRoomsClickHandler = async (item) => {
    let hasChildAgeError = false;
    const childAge = bookingData?.childAge;
    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }

    try {
      await navigate(
        `/single-hotel/${item?.hotel_slug}/${item?.hotel_id}?location=${bookingData.location}&room=1&adult=1&children=0&checkinDay=${bookingData.checkinDay}&checkinMonth=${bookingData.checkinMonth}&checkinYear=${bookingData.checkinYear}&checkoutDay=${bookingData.checkoutDay}&checkoutMonth=${bookingData.checkoutMonth}&checkoutYear=${bookingData.checkoutYear}&hotel_name=${item.hotel_name}&hotel_address=${item.hotel_address}`,
        { state: { item: item } }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoader(false);
    } finally {
      // setLoader(false);
    }
  };

  const fetchDestinations = async (destination) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/destinations/fetch`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // const findImagesArray = result?.data.find(
        //   (item) => item?.name?.toLowerCase() === destination?.toLowerCase()
        // );

        const filterDestination = result?.data.find(
          (item) =>
            item?.name?.toLowerCase().replace(/\s+/g, '-') ===
            destination?.toLowerCase().replace(/\s+/g, '-')
        );
        console.log("filterDestination", filterDestination);
        // setDestinationsImagesArray(findImagesArray?.images)
        setSingleDestinationData(filterDestination);
      })
      .catch((error) => console.error(error));
  };

  const [packageData, setPackageData] = useState([]);
  const [activitiesData, setActivitiesData] = useState([]);
  // console.log(packageData, "packageData");

  const fetchPackageData = async (destination) => {
    // setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    const formdata = new FormData();
    formdata.append("location", destination);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/holidays/fetch`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const result = await response.json();
      // setLoader(false);
      setPackageData(result?.data);
      // const filteredData = result?.data?.filter(
      //   (item) => item.canBookable === 1
      // );
      // setPackageData(filteredData);
    } catch (error) {
      setPackageData([]);
      // setLoader(false);
      console.error(error);
    }
  };
  const fetchActivities = async (destination) => {
    // setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    const formdata = new FormData();
    formdata.append("location", destination);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/activities/fetch`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const result = await response.json();
      // setLoader(false);
      setActivitiesData(result?.data);
      // const filteredData = result?.data?.filter(
      //   (item) => item.canBookable === 1
      // );
      // setPackageData(filteredData);
    } catch (error) {
      setActivitiesData([]);
      // setLoader(false);
      console.error(error);
    }
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const [markupData, setMarkupData] = useState(null);

  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );
          setMarkupData(findObject || null);
        } else {
          setMarkupData("No data found");
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchMarkup();
  }, []);

  const [loader, setLoader] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 500);
  }, []);

  return (
    <div id="singleDestination">
      <PageMetaData
        title={`Properties/Packages In ${capitalizeFirstLetter(
          bookingData.location
        )} - Mountain Mysteries`}
        description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        keywords="hotel management, RevCatalyst, property optimization"
      />
      <OgMetaTitles
        title={`Properties/Packages In ${capitalizeFirstLetter(
          bookingData.location
        )} - Mountain Mysteries`}
        type="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        url={`https://www.mountainmysteries.com/destination/${bookingData.location}`}
        // image={}
      />

      <NewUiHeader />
      {/* <AllHotelsSearchForm searchType="single_destination" /> */}

      <section className="common_padding new_ui_bg">
        {loader ? (
          <div className="container">
            <div className={styles?.single_destination_overview_content}>
              {Array.from({ length: 1 }).map((_, index) => (
                <div className="gallery" key={index}>
                  <div>
                    <Skeleton height={350} />
                  </div>
                  <div className="gallery2">
                    <div>
                      <Skeleton height={170} />
                    </div>
                    <div className="SingleHotel-gallary-sm">
                      <Skeleton height={170} />
                    </div>
                    <div className="SingleHotel-gallary-sm">
                      <Skeleton height={170} />
                    </div>
                    <div className="SingleHotel-gallary-sm">
                      <Skeleton height={170} />
                    </div>
                  </div>
                </div>
              ))}
              <div>
                <h3 style={{ textAlign: "left" }}>
                  <Skeleton width={600} />
                </h3>

                <div className="destinationsCard mt-10">
                  {Array.from({ length: 8 }).map((_, index) => (
                    <div className="card" key={index}>
                      <div className="hotelCardImg">
                        <Skeleton height={170} />
                      </div>
                      <div className="hotel-content-flex hotel-main-card">
                        <div className="" style={{ background: "#fff" }}>
                          <Skeleton height={193} />
                        </div>

                        <div
                          className="hotel-content"
                          style={{ width: "100%" }}
                        >
                          <div className="hotel_main border_0">
                            <h4>
                              <b>
                                <Skeleton width={100} />
                              </b>
                            </h4>
                            <div>
                              <Skeleton width={70} />
                            </div>
                            <small>
                              <Skeleton width={200} />
                            </small>
                            <div className=" flex justify_content_between w-full align_items_end">
                              <div>
                                <p>
                                  <Skeleton width={100} />
                                </p>
                                <h5>
                                  <Skeleton width={50} />
                                </h5>
                              </div>
                              <div className="view_room_btn">
                                <Skeleton />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <section>
              <div className="container">
                <div className={styles?.single_destination_overview_content}>
                  <div
                    style={{ fontWeight: "400", fontSize: "30px" }}
                    className={styles?.font_playfair}
                  >
                    {singleDestinationData?.name}
                  </div>
                  {singleDestinationData && singleDestinationData?.images && (
                    <div className="gallery">
                      <div>
                        <img
                          src={
                            singleDestinationData?.images[0]
                              ? singleDestinationData?.images[0]
                              : imgNotFound
                          }
                          alt="hotel-image"
                        />
                        {singleDestinationData?.images?.length > 1 && (
                          <div>
                            <button
                              className="images_btn"
                              onClick={() => {
                                Fancybox.show(
                                  singleDestinationData?.images?.map((src) => ({
                                    src,
                                    type: "image",
                                  }))
                                );
                              }}
                            >
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 16 15"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M8 11.625C8.9375 11.625 9.73438 11.2969 10.3906 10.6406C11.0469 9.98438 11.375 9.1875 11.375 8.25C11.375 7.3125 11.0469 6.51562 10.3906 5.85938C9.73438 5.20312 8.9375 4.875 8 4.875C7.0625 4.875 6.26562 5.20312 5.60938 5.85938C4.95312 6.51562 4.625 7.3125 4.625 8.25C4.625 9.1875 4.95312 9.98438 5.60938 10.6406C6.26562 11.2969 7.0625 11.625 8 11.625ZM8 10.125C7.475 10.125 7.03125 9.94375 6.66875 9.58125C6.30625 9.21875 6.125 8.775 6.125 8.25C6.125 7.725 6.30625 7.28125 6.66875 6.91875C7.03125 6.55625 7.475 6.375 8 6.375C8.525 6.375 8.96875 6.55625 9.33125 6.91875C9.69375 7.28125 9.875 7.725 9.875 8.25C9.875 8.775 9.69375 9.21875 9.33125 9.58125C8.96875 9.94375 8.525 10.125 8 10.125ZM2 14.25C1.5875 14.25 1.23438 14.1031 0.940625 13.8094C0.646875 13.5156 0.5 13.1625 0.5 12.75V3.75C0.5 3.3375 0.646875 2.98438 0.940625 2.69063C1.23438 2.39688 1.5875 2.25 2 2.25H4.3625L5.75 0.75H10.25L11.6375 2.25H14C14.4125 2.25 14.7656 2.39688 15.0594 2.69063C15.3531 2.98438 15.5 3.3375 15.5 3.75V12.75C15.5 13.1625 15.3531 13.5156 15.0594 13.8094C14.7656 14.1031 14.4125 14.25 14 14.25H2ZM2 12.75H14V3.75H10.9625L9.59375 2.25H6.40625L5.0375 3.75H2V12.75Z" />
                              </svg>
                              See all images
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="gallery2">
                        <div>
                          <img
                            src={
                              singleDestinationData?.images[1]
                                ? singleDestinationData?.images[1]
                                : imgNotFound
                            }
                            alt="hotel-image"
                          />
                        </div>
                        <div className="SingleHotel-gallary-sm">
                          <img
                            src={
                              singleDestinationData?.images[2]
                                ? singleDestinationData?.images[2]
                                : imgNotFound
                            }
                            alt="hotel-image"
                          />
                        </div>
                        <div className="SingleHotel-gallary-sm">
                          <img
                            src={
                              singleDestinationData?.images[3]
                                ? singleDestinationData?.images[3]
                                : imgNotFound
                            }
                            alt="hotel-image"
                          />
                        </div>
                        <div className="SingleHotel-gallary-sm">
                          <img
                            src={
                              singleDestinationData?.images[4]
                                ? singleDestinationData?.images[4]
                                : imgNotFound
                            }
                            alt="hotel-image"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <p
                    className={`${styles.description}`}
                    dangerouslySetInnerHTML={{
                      __html: singleDestinationData?.description,
                    }}
                  ></p>
                </div>
              </div>
            </section>

            {packageData && packageData?.length > 0 && (
              <section className="top_bottom_padding_white">
                <div className="container">
                  <div className={styles.heading_div}>
                    <h3> Popular {bookingData?.location} Packages</h3>
                    <Link to={"/all-packages"} className={styles.view_all_btn}>
                      View All
                    </Link>
                  </div>
                  <div>
                    <div className="destinationsCard m_0 relative">
                      {packageData && packageData?.length > 0 ? (
                        packageData?.slice(0, 3).map((items, index) => {
                          return (
                            <NewUIPackageCard
                              key={index}
                              imgSrc={items?.featuredImage || imgNotFound}
                              title={items.packageName}
                              packageHub={items.packageHub}
                              duration={items.totalDays}
                              nightDuration={items.totalNights}
                              price={items.startingPrice}
                              bookingLink={items.bookingLink}
                              detailsLink={items.detailsLink}
                              packagehandle={items.packagehandle}
                              canBookable={items?.canBookable}
                              packageId={items.packageId}
                              setShowSendEnquiryPopup={setShowSendEnquiryPopup}
                              markupData={markupData}
                              NoPax={items?.NoPax}
                              packageItinerary={items?.packageItinerary}
                            />
                          );
                        })
                      ) : (
                        <NoDataFound />
                      )}
                    </div>
                  </div>
                </div>
              </section>
            )}

            <div className="mt-10 text_left top_bottom_same_padding bg-white font_family_hotelcard">
              {" "}
              <HotelCard
                titleLeft={true}
                heading="Top Properties in Himachal Pradesh"
              />
            </div>
            {activitiesData && activitiesData?.length > 0 && (
              <section className="top_bottom_padding_white">
                <div className="container">
                  <div className={styles.heading_div}>
                    <h3 className="text-capitalize">
                      {" "}
                      Popular Activities In {bookingData?.location}
                    </h3>
                    <Link
                      to={"/all-activities"}
                      className={styles.view_all_btn}
                    >
                      View All
                    </Link>
                  </div>
                  <div>
                    <div className="destinationsCard m_0">
                      {activitiesData && activitiesData?.length > 0 ? (
                        activitiesData?.slice(0, 3).map((data, index) => {
                          return (
                            <NewUIActivitypageCard
                              key={index}
                              imgSrc={
                                data.featuredImage
                                  ? data.featuredImage
                                  : imgNotFound
                              }
                              title={data.activityName}
                              packageHub={data.packageHub}
                              duration={1}
                              nightDuration={data.totalNights}
                              price={data.startingPrice}
                              bookingLink={data.bookingLink}
                              detailsLink={data.detailsLink}
                              packagehandle={data.packagehandle}
                              canBookable={data?.canBookable}
                              description={data?.content}
                              id={data?.activityId}
                              slug={data?.activityHandle}
                              setShowSendEnquiryPopup={setshowRatePopup}
                              markupData={markupData}
                              sendEnquiry={() => {
                                // setSelectedActivity(data);
                                setshowRatePopup(true);
                              }}
                              activityDestination={data?.activityDestination}
                            />
                          );
                        })
                      ) : (
                        <NoDataFound />
                      )}
                    </div>
                  </div>
                </div>
              </section>
            )}
          </>
        )}
        {showRatePopup && (
          <ActivityQueryFormPopup
            package_id={activitiesData?.id}
            setshowRatePopup={setshowRatePopup}
            typeDetail="activity"
            activityDestination={activitiesData?.activityDestination}
            singleActivityData={activitiesData}
          />
        )}
      </section>
      <NewFooterUI />
    </div>
  );
}

export default SingleDestinationsData;
